"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PolygonExtracter = _interopRequireDefault(require("../../geom/util/PolygonExtracter"));

var _STRtree = _interopRequireDefault(require("../../index/strtree/STRtree"));

var _Geometry = _interopRequireDefault(require("../../geom/Geometry"));

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _GeometryFactory = _interopRequireDefault(require("../../geom/GeometryFactory"));

var _GeometryCombiner = _interopRequireDefault(require("../../geom/util/GeometryCombiner"));

var _Polygonal = _interopRequireDefault(require("../../geom/Polygonal"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _List = _interopRequireDefault(require("../../../../../java/util/List"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CascadedPolygonUnion =
/*#__PURE__*/
function () {
  function CascadedPolygonUnion() {
    _classCallCheck(this, CascadedPolygonUnion);

    CascadedPolygonUnion.constructor_.apply(this, arguments);
  }

  _createClass(CascadedPolygonUnion, [{
    key: "reduceToGeometries",
    value: function reduceToGeometries(geomTree) {
      var geoms = new _ArrayList.default();

      for (var i = geomTree.iterator(); i.hasNext();) {
        var o = i.next();
        var geom = null;

        if ((0, _hasInterface.default)(o, _List.default)) {
          geom = this.unionTree(o);
        } else if (o instanceof _Geometry.default) {
          geom = o;
        }

        geoms.add(geom);
      }

      return geoms;
    }
  }, {
    key: "extractByEnvelope",
    value: function extractByEnvelope(env, geom, disjointGeoms) {
      var intersectingGeoms = new _ArrayList.default();

      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var elem = geom.getGeometryN(i);
        if (elem.getEnvelopeInternal().intersects(env)) intersectingGeoms.add(elem);else disjointGeoms.add(elem);
      }

      return this._geomFactory.buildGeometry(intersectingGeoms);
    }
  }, {
    key: "unionOptimized",
    value: function unionOptimized(g0, g1) {
      var g0Env = g0.getEnvelopeInternal();
      var g1Env = g1.getEnvelopeInternal();

      if (!g0Env.intersects(g1Env)) {
        var combo = _GeometryCombiner.default.combine(g0, g1);

        return combo;
      }

      if (g0.getNumGeometries() <= 1 && g1.getNumGeometries() <= 1) return this.unionActual(g0, g1);
      var commonEnv = g0Env.intersection(g1Env);
      return this.unionUsingEnvelopeIntersection(g0, g1, commonEnv);
    }
  }, {
    key: "union",
    value: function union() {
      if (this._inputPolys === null) throw new IllegalStateException("union() method cannot be called twice");
      if (this._inputPolys.isEmpty()) return null;
      this._geomFactory = this._inputPolys.iterator().next().getFactory();
      var index = new _STRtree.default(CascadedPolygonUnion.STRTREE_NODE_CAPACITY);

      for (var i = this._inputPolys.iterator(); i.hasNext();) {
        var item = i.next();
        index.insert(item.getEnvelopeInternal(), item);
      }

      this._inputPolys = null;
      var itemTree = index.itemsTree();
      var unionAll = this.unionTree(itemTree);
      return unionAll;
    }
  }, {
    key: "binaryUnion",
    value: function binaryUnion() {
      if (arguments.length === 1) {
        var geoms = arguments[0];
        return this.binaryUnion(geoms, 0, geoms.size());
      } else if (arguments.length === 3) {
        var _geoms = arguments[0],
            start = arguments[1],
            end = arguments[2];

        if (end - start <= 1) {
          var g0 = CascadedPolygonUnion.getGeometry(_geoms, start);
          return this.unionSafe(g0, null);
        } else if (end - start === 2) {
          return this.unionSafe(CascadedPolygonUnion.getGeometry(_geoms, start), CascadedPolygonUnion.getGeometry(_geoms, start + 1));
        } else {
          var mid = Math.trunc((end + start) / 2);
          var g0 = this.binaryUnion(_geoms, start, mid);
          var g1 = this.binaryUnion(_geoms, mid, end);
          return this.unionSafe(g0, g1);
        }
      }
    }
  }, {
    key: "repeatedUnion",
    value: function repeatedUnion(geoms) {
      var union = null;

      for (var i = geoms.iterator(); i.hasNext();) {
        var g = i.next();
        if (union === null) union = g.copy();else union = union.union(g);
      }

      return union;
    }
  }, {
    key: "unionSafe",
    value: function unionSafe(g0, g1) {
      if (g0 === null && g1 === null) return null;
      if (g0 === null) return g1.copy();
      if (g1 === null) return g0.copy();
      return this.unionOptimized(g0, g1);
    }
  }, {
    key: "unionActual",
    value: function unionActual(g0, g1) {
      return CascadedPolygonUnion.restrictToPolygons(g0.union(g1));
    }
  }, {
    key: "unionTree",
    value: function unionTree(geomTree) {
      var geoms = this.reduceToGeometries(geomTree);
      var union = this.binaryUnion(geoms);
      return union;
    }
  }, {
    key: "unionUsingEnvelopeIntersection",
    value: function unionUsingEnvelopeIntersection(g0, g1, common) {
      var disjointPolys = new _ArrayList.default();
      var g0Int = this.extractByEnvelope(common, g0, disjointPolys);
      var g1Int = this.extractByEnvelope(common, g1, disjointPolys);
      var union = this.unionActual(g0Int, g1Int);
      disjointPolys.add(union);

      var overallUnion = _GeometryCombiner.default.combine(disjointPolys);

      return overallUnion;
    }
  }, {
    key: "bufferUnion",
    value: function bufferUnion() {
      if (arguments.length === 1) {
        var geoms = arguments[0];
        var factory = geoms.get(0).getFactory();
        var gColl = factory.buildGeometry(geoms);
        var unionAll = gColl.buffer(0.0);
        return unionAll;
      } else if (arguments.length === 2) {
        var g0 = arguments[0],
            g1 = arguments[1];
        var factory = g0.getFactory();
        var gColl = factory.createGeometryCollection([g0, g1]);
        var unionAll = gColl.buffer(0.0);
        return unionAll;
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CascadedPolygonUnion;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "restrictToPolygons",
    value: function restrictToPolygons(g) {
      if ((0, _hasInterface.default)(g, _Polygonal.default)) {
        return g;
      }

      var polygons = _PolygonExtracter.default.getPolygons(g);

      if (polygons.size() === 1) return polygons.get(0);
      return g.getFactory().createMultiPolygon(_GeometryFactory.default.toPolygonArray(polygons));
    }
  }, {
    key: "getGeometry",
    value: function getGeometry(list, index) {
      if (index >= list.size()) return null;
      return list.get(index);
    }
  }, {
    key: "union",
    value: function union(polys) {
      var op = new CascadedPolygonUnion(polys);
      return op.union();
    }
  }]);

  return CascadedPolygonUnion;
}();

exports.default = CascadedPolygonUnion;

CascadedPolygonUnion.constructor_ = function () {
  this._inputPolys = null;
  this._geomFactory = null;
  var polys = arguments[0];
  this._inputPolys = polys;
  if (this._inputPolys === null) this._inputPolys = new _ArrayList.default();
};

CascadedPolygonUnion.STRTREE_NODE_CAPACITY = 4;